/**
 * Defines a satisfies function that can be used test values yielding either true, false, or null
 */
export default {

  /**
    * Determines whether the targetValue satisfies the comparitor given the two possible values.
    * @return {boolean or null} depending on whether the data fields are known. Null means that it is
    * unclear if the target satisfies the condition
    */
  satisfies( targetValue, cmp, value1, value2, coerceValue ) {
    
    if ( targetValue === undefined ) {
      return cmp === 'exists' ? false : ( cmp === 'doesNotExist' ? true : null )
    } else {
      if ( cmp === 'exists' ) {
        return true
      }
      if ( cmp === 'doesNotExist' ) {
        return false
      }
    }

    let cv = coerceValue
    let targetType = typeof targetValue
    if ( targetType === 'string' ) {
      targetValue = targetValue.trim()
    } else {
      cv = false
    }
    
    if ( cmp === '===' ) {
      // eslint-disable-next-line eqeqeq
      return targetValue == value1 || ( cv && parseFloat( targetValue ) == value1 )
    }
    if ( cmp === 'startsWith' ) {
      if ( targetType === 'string' ) {
        return targetValue.startsWith( value1 )
      }
      if ( targetType === 'number' ) {
        return targetValue.toString().startsWith( value1 )
      }
      return false
    }

    if ( cmp === 'endsWith' ) {
      if ( targetType === 'string' ) {
        return targetValue.endsWith( value1 )
      }
      if ( targetType === 'number' ) {
        return targetValue.toString().endsWith( value1 )
      }
      return false
    }

    if ( cmp === 'contains' ) {
      if ( targetType === 'string' ) {
        return targetValue.indexOf( value1 ) >= 0
      }
      if ( targetType === 'number' ) {
        return targetValue.toString().indexOf( value1 ) >= 0
      }
      return false
    }

    if ( cmp === '!==' ) {
      // eslint-disable-next-line eqeqeq
      return !( targetValue == value1 || ( cv && parseFloat( targetValue ) == value1 ) )
    }

    if ( cv && targetType !== 'number' ) {
      targetValue = parseFloat( targetValue )
      if ( Number.isNaN( targetValue ) ) {
        return null
      }
      targetType = typeof targetValue
    }

    // Number stuff beneath
    if ( targetType !== 'number' ) {
      return null
    }

    switch ( cmp ) {
      case '<': {
        return targetValue < value1 
      }
      case '<=': {
        return targetValue <= value1
      }
      case '>': {
        return targetValue > value1
      }
      case '>=': {
        return targetValue >= value1
      }
      case '[]': {
        if ( typeof value2 === 'number' ) {
          return value1 <= targetValue && targetValue <= value2
        }
        return null
      }
      case '[)': {
        if ( typeof value2 === 'number' ) {
          return value1 <= targetValue && targetValue < value2
        }
        return null
      }
      case '(]': {
        if ( typeof value2 === 'number' ) {
          return value1 < targetValue && targetValue <= value2
        }
        return null
      }
      case '()': {
        if ( typeof value2 === 'number' ) {
          return value1 < targetValue && targetValue < value2
        }
        return null
      }
      default:
        return null
    }
  }
}
